import React from 'react';
import Rodal from 'rodal';
import { Link } from 'react-router-dom';
import guest from 'src/images/guest.svg';

const GuestModal = ({ isOpen, onSignUp, onLoguot, onCancel }) => {
  const handleCancel = () => {
    onCancel()
  };

  return (
    <Rodal
      width={430}
      height={340}
      showCloseButton={false}
      visible={isOpen}
      onClose={handleCancel}
    >
      <div className="guest-modal">
        <div className="img-container">
          <img src={guest} alt="img" />
        </div>
        <h1>You are signed-in as a Guest user</h1>
        <p>
          <Link to={' '} onClick={onSignUp}>
            Sign up
          </Link>{' '}
          to create your own POPin!
        </p>
        <p>
          Already have an account?
          <br />
          <Link to={' '} onClick={onLoguot}>
            Log out
          </Link>{' '}
          of your Guest account and {'\n'}
          log back in with your work email.
        </p>
        <button onClick={onSignUp} className="btn btn-submit">
          Sign up
        </button>
        <button onClick={onLoguot} className="btn btn-flat">
          Login
        </button>
      </div>
    </Rodal>
  );
};

export default GuestModal;
